/* ============================================================
   NATUKA — MENÚ COCINADO CERDO AHUMADO
   main.js
   ============================================================ */

'use strict';

// ── STATE ───────────────────────────────────────────────────
let selectedVariantId = null; // se fija al primer botón .active en init
let quantity = 1;

// ── DOM REFS ────────────────────────────────────────────────
const qtyMinus  = document.getElementById('qty-minus');
const qtyPlus   = document.getElementById('qty-plus');
const qtyValue  = document.getElementById('qty-value');
const addBtn    = document.getElementById('add-to-cart-btn');
const addBtn2   = document.getElementById('add-to-cart-btn-2');
const feedback  = document.getElementById('cart-feedback');
const feedback2 = document.getElementById('cart-feedback-2');

// ── VARIANT SELECTION ───────────────────────────────────────
function initVariantButtons() {
  const priceEls = document.querySelectorAll('.selected-price');

  function updateSelectedPrice(variantId) {
    const btnWithPrice = document.querySelector(`.variant-btn[data-variant="${variantId}"][data-price]`);

    if (btnWithPrice && btnWithPrice.dataset.price) {
      priceEls.forEach(el => {
        el.textContent = btnWithPrice.dataset.price;
      });
    }
  }

  const firstActive = document.querySelector('.variant-btn.active');

  if (firstActive) {
    selectedVariantId = firstActive.dataset.variant;
    updateSelectedPrice(selectedVariantId);
  }

  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      selectedVariantId = btn.dataset.variant;

      document.querySelectorAll('.variant-btn').forEach(b => {
        b.classList.toggle('active', b.dataset.variant === selectedVariantId);
      });

      updateSelectedPrice(selectedVariantId);
    });
  });
}

// ── QUANTITY ────────────────────────────────────────────────
function initQtyControls() {
  // Hero qty
  qtyMinus && qtyMinus.addEventListener('click', () => {
    if (quantity > 1) { quantity--; qtyValue.textContent = quantity; }
  });
  qtyPlus && qtyPlus.addEventListener('click', () => {
    quantity++;
    qtyValue.textContent = quantity;
  });

  // Final CTA qty
  const qtyMinus2 = document.getElementById('qty-minus-2');
  const qtyPlus2  = document.getElementById('qty-plus-2');
  const qtyVal2   = document.getElementById('qty-value-2');
  let quantity2 = 1;

  qtyMinus2 && qtyMinus2.addEventListener('click', () => {
    if (quantity2 > 1) { quantity2--; qtyVal2.textContent = quantity2; }
  });
  qtyPlus2 && qtyPlus2.addEventListener('click', () => {
    quantity2++;
    qtyVal2.textContent = quantity2;
  });

  // Override addToCart for btn-2 to use quantity2
  const btn2 = document.getElementById('add-to-cart-btn-2');
  const fb2  = document.getElementById('cart-feedback-2');
  btn2 && btn2.addEventListener('click', () => addToCartQty(fb2, btn2, quantity2));
}

// ── ADD TO CART (Shopify Cart API) ──────────────────────────
// Strings come from locales via sb-cerdo-ahumado.liquid
const sbStrings = window.SB_STRINGS || {};

async function addToCartQty(feedbackEl, buttonEl, qty) {
  const variantId = selectedVariantId;

  if (!variantId || variantId.startsWith('VARIANT_ID')) {
    feedbackEl.textContent = sbStrings.unavailable;
    feedbackEl.style.color = '#ff4444';
    return;
  }

  const originalHTML = buttonEl.innerHTML;
  buttonEl.disabled = true;
  buttonEl.querySelector('.cta-primary__text').textContent = sbStrings.adding;
  feedbackEl.textContent = '';
  feedbackEl.style.color = '#ffee23';

  try {
    const response = await fetch(window.SB_CART_ADD_URL || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty }),
    });

    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.description || sbStrings.addError);
    }

    buttonEl.querySelector('.cta-primary__text').textContent = sbStrings.added;
    feedbackEl.textContent = sbStrings.redirecting;
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    setTimeout(() => {
      window.location.href = window.SB_CART_URL || '/cart';
    }, 800);

  } catch (err) {
    console.error('[Natuka cart]', err);
    feedbackEl.textContent = err.message || sbStrings.genericError;
    feedbackEl.style.color = '#ff4444';
    buttonEl.innerHTML = originalHTML;
    buttonEl.disabled = false;
  }
}

async function addToCart(feedbackEl, buttonEl) {
  return addToCartQty(feedbackEl, buttonEl, quantity);
}

function initCartButtons() {
  addBtn && addBtn.addEventListener('click', () => addToCart(feedback, addBtn));
  // btn-2 is wired in initQtyControls with its own quantity
}

// ── VIDEO OVERLAY ───────────────────────────────────────────
// ── VIDEO BUTTON ────────────────────────────────────────────
function initVideo() {
  const btn   = document.getElementById('video-play-btn');
  const video = document.getElementById('spot-video');

  if (!btn || !video) return;

  btn.addEventListener('click', function() {
    video.controls = true;
    video.play();
    btn.classList.add('is-hidden');
  });

  video.addEventListener('pause', function() {
    if (!video.ended) {
      btn.classList.remove('is-hidden');
    }
  });

  video.addEventListener('play', function() {
    btn.classList.add('is-hidden');
  });

  video.addEventListener('ended', function() {
    btn.classList.remove('is-hidden');
    video.currentTime = 0;
  });
}

// ── INGREDIENT BARS ANIMATION (IntersectionObserver) ────────
function initIngredientBars() {
  const bars = document.querySelectorAll('.ing-bar');
  if (!bars.length) return;

  // Restablece a 0 para animar al entrar en viewport
  bars.forEach(bar => {
    bar.style.width = '0%';
  });

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.querySelectorAll('.ing-bar').forEach(bar => {
          bar.style.width = `calc(var(--pct) * 1%)`;
        });
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  const list = document.querySelector('.ingredients-list');
  list && observer.observe(list);
}

// ── INIT ────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  initVariantButtons();
  initQtyControls();
  initCartButtons();
  initVideo();
  initIngredientBars();
});

